import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { CONTACT } from '../data/media';
export function FloatingActions() {
  const {
    t
  } = useLanguage();
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className="fixed bottom-4 right-4 z-40 flex flex-col items-end gap-3" data-id="element-108" data-mp="efb7rkknv5tp">
      <AnimatePresence data-id="element-109" data-mp="jdw61egcrffi">
        {showTop ? <motion.button type="button" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} aria-label="Back to top" className="inline-flex h-11 w-11 items-center justify-center rounded bg-brand-500 text-ink shadow-lift transition-colors duration-200 ease-smooth hover:bg-brand-400" initial={{
        opacity: 0,
        scale: 0.96,
        y: 8
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 8
      }} transition={{
        duration: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-110" data-mp="jcl1hcf323nc">
            <ArrowUpIcon className="h-5 w-5" aria-hidden="true" data-id="element-111" data-mp="2c8wzq8nerai" />
          </motion.button> : null}
      </AnimatePresence>

      <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lift transition-transform duration-200 ease-smooth hover:scale-105" data-id="element-112" data-mp="yykjf6loo5oe">
        <MessageCircleIcon className="h-6 w-6" aria-hidden="true" data-id="element-113" data-mp="3ar0qd28ovpth" />
      </a>

      <a href={`tel:+1${CONTACT.phoneRaw}`} aria-label={`${t.hero.callNow} ${CONTACT.phoneDisplay}`} className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-brand-500 text-ink shadow-lift transition-transform duration-200 ease-smooth hover:scale-105" data-id="element-114" data-mp="35recqroy87k5">
        <PhoneIcon className="h-6 w-6" aria-hidden="true" data-id="element-115" data-mp="2y85d3q68vn8a" />
      </a>
    </div>;
}